import { h, Host } from "@stencil/core";
import { AppState } from "../../service/app-state";
export class ButtonToggleOffcanvas {
    constructor() {
        this.open = false;
        this.changeListener = () => {
            this.open = AppState.offcanvas;
        };
    }
    componentDidLoad() {
        this.open = AppState.offcanvas;
        AppState.addEventListener(this.changeListener);
    }
    disconnectedCallback() {
        AppState.removeEventListener(this.changeListener);
    }
    onClick() {
        AppState.toggleOffcanvas();
        this.open = AppState.offcanvas;
    }
    render() {
        return (h(Host, { key: '5c50591aab5b2115bab85d6f3a60133c5ea7088a', role: "button", class: {
                'active': this.open
            } }, h("span", { key: '9a7ed2d513984ae2784302a3d955b77c0205d886' })));
    }
    static get is() { return "uvex-button-toggle-offcanvas"; }
    static get originalStyleUrls() {
        return {
            "$": ["./button-toggle-offcanvas.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["button-toggle-offcanvas.css"]
        };
    }
    static get states() {
        return {
            "open": {}
        };
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=button-toggle-offcanvas.js.map
